import { RouteConfig } from 'vue-router';
import OnboardingSeeker from '@/apps/onboarding/seeker/OnboardingSeeker.vue';
import OnboardingSeekerLocation from '@/apps/onboarding/seeker/steps/OnboardingSeekerLocation.vue';
import OnboardingSeekerCareNearYou from '@/apps/onboarding/seeker/steps/OnboardingSeekerCareNearYou.vue';

const onboardingSeekerRoutes: RouteConfig[] = [
  {
    path: '/onboarding/seeker',
    component: OnboardingSeeker,
    children: [
      {
        path: 'location',
        name: 'onboarding-seeker-location',
        component: OnboardingSeekerLocation,
      },
      {
        path: 'care-near-you',
        name: 'onboarding-seeker-care-near-you',
        component: OnboardingSeekerCareNearYou,
      },
      { path: '*', redirect: { name: 'onboarding-seeker-location' } },
      { path: '', redirect: { name: 'onboarding-seeker-location' } },
    ],
  },
];

export default onboardingSeekerRoutes;
